export function getDisplayGrade(grade: string) {
    if (grade === '6' || grade === '6M') {
        return '6';
    }
    return grade.toUpperCase();
}
